import React from 'react';
import { useLanguage } from '../../../../contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const languages = [
    { code: 'en' as const, label: 'EN' },
    { code: 'es' as const, label: 'ES' },
  ];

  return (
    <div className="inline-flex items-center gap-1 border border-white/10 bg-surface p-1" role="group" aria-label="Language">
      {languages.map((lang) => (
        <button
          key={lang.code}
          type="button"
          onClick={() => setLanguage(lang.code)}
          className={`min-w-[2.25rem] px-2 py-1 text-xs font-semibold tracking-wide transition-colors duration-200 ${
            language === lang.code
              ? 'bg-accent text-fg'
              : 'text-muted hover:text-fg'
          }`}
          aria-pressed={language === lang.code}
          aria-label={`Switch to ${lang.label}`}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export { LanguageSwitcher };
